import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function UniqueMethod() {
  return <section className="py-24 px-4 bg-navy-800 relative overflow-hidden" data-id="element-154">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-155" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-156">
        <FadeIn data-id="element-157">
          <div className="text-center mb-12" data-id="element-158">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-accent-500/10 text-accent-400 mb-6" data-id="element-159">
              <ShieldCheck className="w-8 h-8" data-id="element-160" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-161">
              El Método para tu{' '}
              <span className="text-transparent bg-clip-text bg-accent-gradient" data-id="element-162">
                Primer Trabajo Remoto
              </span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-163">
          <div className="bg-gradient-to-br from-navy-700 to-navy-900 p-8 md:p-12 rounded-3xl border border-accent-500/20 shadow-2xl" data-id="element-164">
            <p className="text-xl md:text-2xl text-white font-medium mb-6 leading-relaxed" data-id="element-165">
              Este sistema no se trata de pedir una oportunidad, sino de
              presentarte como una{' '}
              <strong className="text-accent-400" data-id="element-166">
                inversión de bajo riesgo
              </strong>
              .
            </p>
            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-167">
              Aprenderás a auditar tus habilidades actuales y "traducirlas" al
              lenguaje corporativo global. Al eliminar cada duda técnica,
              cultural y operativa del reclutador antes de la primera
              entrevista, dejas de ser un candidato del tercer mundo para
              convertirte en la solución más eficiente y rentable para su
              equipo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}